import PrimaryButton from "../PrimaryButton";
import styles from "./userprofile.module.css";
import TextField from "@mui/material/TextField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast, Bounce } from "react-toastify";
import InputOTP from "../InputOTP";
import logo from "../../assets/logo.png";
import {
  getUserMeta,
  UpdateUserInfo,
  UpdateUserAddress,
  UpdateUserMail,
  UpdateUserPhone,
  UpdateUserAvatar,
} from "../../apis/user";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import AddressInputModal from "../AddressInputModal";
import ImageWithFallback from '../ImageWithFallback';

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function UserProfileBlock() {
  const { t } = useTranslation();

  const [open, setOpen] = useState({
    isEmail: false,
    isPhone: false,
    isDateOfBirth: false,
    isAddress: false,
  });

  const [cookies, setCookie] = useCookies(["access_token", "user_info"]);

  const [userProfile, setUserProfile] = useState({
    username: "",
    name: t("not_set"),
    email: t("not_set"),
    phone: t("not_set"),
    gender: t("not_set"),
    dob: t("not_set"),
    street: t("not_set"),
    ward: t("not_set"),
    district: t("not_set"),
    city: t("not_set"),
    avatar: logo,
  });

  const [OTP, setOTP] = useState("");

  const [error, setError] = useState({
    email: false,
    phone: false,
    dob: false,
  });

  useEffect(() => {
    getUserMeta(cookies.access_token).then((result) => {
      const userData = result.data;

      const userMetadata = result.data.metadata;

      let expires = new Date();
      expires.setTime(expires.getTime() + 7 * 24 * 60 * 60 * 1000);

      setCookie("user_info", JSON.stringify(userData), {
        path: "/",
        expires: expires,
        maxAge: 7 * 24 * 60 * 60,
        secure: true,
        sameSite: "strict",
      });

      if (userMetadata)
        setUserProfile({
          ...userProfile,
          name:
            userMetadata.fullName ??
            userMetadata.firstName + " " + userMetadata.lastName,
          street: userMetadata.street,
          ward: userMetadata.ward,
          district: userMetadata.district,
          city: userMetadata.city,
          email: userData.email,
          phone: userData.phone,
          gender: userMetadata.gender,
          dob: formatDateForInput(userMetadata.dateOfBirth),
          avatar: userMetadata.avatar,
        });
      else
        setUserProfile({
          ...userProfile,
          email: userData.email,
          phone: userData.phone ?? t("not_set"),
          avatar: logo,
        });
    });
  }, []);

  // useEffect(() => {
  //   try {
  //     if (isNaN(new Date(userProfile.dob).getTime())) {
  //       return;
  //     }

  //     const formattedDOB = new Date(userProfile.dob).toLocaleDateString('en-GB', {
  //       year: 'numeric',
  //       month: '2-digit',
  //       day: '2-digit'
  //     });

  //     console.log(new Date(userProfile.dob))
  //     console.log(formattedDOB)

  //     setUserProfile({
  //       ...userProfile,
  //       dob: formattedDOB
  //     });
  //   } catch { }
  // }, [userProfile.dob])

  function formatDateForInput(dateStr) {
    let date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      console.error("Invalid date");
      return "";
    }

    let year = date.getFullYear();
    let month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero-based
    let day = ("0" + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  const handleOpen = (type) => {
    setOpen({
      ...open,
      [type]: true,
    });
  };

  const handleClose = () => {
    setOpen({
      isEmail: false,
      isPhone: false,
      isDateOfBirth: false,
      isAddress: false,
    });
  };

  const handleSaveEmail = () => {
    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await UpdateUserMail(
          userProfile.email,
          cookies["access_token"]
        );
        if (result.status === 200) resolve(result);
        else reject(result);
      }),
      {
        pending: {
          render() {
            return t("submitting");
          },
          position: "top-center",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        success: {
          render({ data }) {
            setUserProfile({
              ...userProfile,
              email: data,
            });
            handleClose();
            return t("mail_changed");
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        error: {
          render({ data }) {
            return `${t("error_occurred")}: ${
              data.response?.data?.message || data.message
            }`;
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
      }
    );
  };

  const handleSavePhone = () => {
    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await UpdateUserPhone(
          userProfile.phone,
          cookies["access_token"]
        );
        if (result.status === 200) resolve(result);
        else reject(result);
      }),
      {
        pending: {
          render() {
            return t("submitting");
          },
          position: "top-center",
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        success: {
          render({ data }) {
            setUserProfile({
              ...userProfile,
              phone: data,
            });
            handleClose();
            return t("phone_changed");
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
        error: {
          render({ data }) {
            return `${t("error_occurred")}: ${
              data.response?.data?.message || data.message
            }`;
          },
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          transition: Bounce,
        },
      }
    );
  };

  const handleSaveDOB = () => {
    if (error.dob) {
      toast.error(t("dob_invalid"));
    } else {
      handleClose();
    }
  };
  const handleSaveAddress = (address) => {
    if (error.address) {
      toast.error("Địa chỉ không hợp lệ!");
    } else {
      toast.promise(
        new Promise(async (resolve, reject) => {
          const result = await UpdateUserAddress(
            {
              street: address.plusAddress,
              ward: address.selectedWardName,
              district: address.selectedDistrictName,
              city: address.selectedCityName,
            },
            cookies["access_token"]
          );
          if (result.status === 200) resolve(result);
          else reject(result);
        }),
        {
          pending: {
            render() {
              return t("submitting");
            },
            position: "top-center",
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Bounce,
          },
          success: {
            render({ data }) {
              setUserProfile({
                ...userProfile,
                street: address.plusAddress,
                ward: address.selectedWardName,
                district: address.selectedDistrictName,
                city: address.selectedCityName,
              });
              handleClose();
              return t("address_changed");
            },
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Bounce,
          },
          error: {
            render({ data }) {
              return `${t("error_occurred")}: ${
                data.response?.data?.message || data.message
              }`;
            },
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "light",
            transition: Bounce,
          },
        }
      );
    }
  };
  const handleEmailChange = (value) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setUserProfile({ ...userProfile, email: value });
    if (value === "" || emailRegex.test(value)) {
      setError({ email: false });
    } else {
      setError({ email: true });
    }
  };

  const handlePhoneChange = (value) => {
    const phoneRegex = /^\+?[0-9]\d{9}$/;
    setUserProfile({
      ...userProfile,
      phone: value,
    });
    if (value === "" || phoneRegex.test(value)) {
      setError({ phone: false });
    } else {
      setError({ phone: true });
    }
  };

  const handleDOBChange = (value) => {
    setUserProfile({
      ...userProfile,
      dob: value,
    });
    const dobRegex = /^(19|20)\d\d-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    if (value === "" || dobRegex.test(value)) {
      setError((prevError) => ({ ...prevError, dob: false }));
    } else {
      setError((prevError) => ({ ...prevError, dob: true }));
    }
  };

  // Handle Address Change
  const handleCityChange = (value) => {
    setUserProfile({
      ...userProfile,
      city: value,
    });
    if (value === "") {
      setError({ city: true });
    } else {
      setError({ city: false });
    }
  };

  const handleDistrictChange = (value) => {
    setUserProfile({
      ...userProfile,
      district: value,
    });
    if (value === "") {
      setError({ district: true });
    } else {
      setError({ district: false });
    }
  };

  const handleWardChange = (value) => {
    setUserProfile({
      ...userProfile,
      ward: value,
    });
    if (value === "") {
      setError({ ward: true });
    } else {
      setError({ ward: false });
    }
  };

  const handleStreetChange = (value) => {
    setUserProfile({
      ...userProfile,
      street: value,
    });
    if (value === "") {
      setError({ street: true });
    } else {
      setError({ street: false });
    }
  };

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    var formData = new FormData();
    formData.append("UserId", cookies["user_info"].id);
    formData.append("Avatar", file);
    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await UpdateUserAvatar(
          formData,
          cookies["access_token"]
        );
        if (result.status === 200) resolve(result);
        else reject(result);
      }),
      {
        pending: {
          render() {
            return t("submitting");
          },
        },
        success: {
          render({ data }) {
            const reader = new FileReader();
            reader.onloadend = (e) => {
              setUserProfile({
                ...userProfile,
                avatar: e.target.result,
              });
            };
            reader.readAsDataURL(file);
            return t("user_avatar_updated");
          },
        },
        error: {
          render({ data }) {
            return `${t("error_occurred")}: ${
              data.response?.data?.message || data.message
            }`;
          },
        },
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    toast.promise(
      new Promise(async (resolve, reject) => {
        const result = await UpdateUserInfo(
          userProfile,
          cookies["access_token"]
        );
        if (result.status === 200) resolve(result);
        else reject(result);
      }),
      {
        pending: {
          render() {
            return t("submitting");
          },
        },
        success: {
          render({ data }) {
            return t("user_profile_updated");
          },
        },
        error: {
          render({ data }) {
            return `${t("error_occurred")}: ${
              data.response?.data?.message || data.message
            }`;
          },
        },
      }
    );
  };

  return (
    <div className={styles.userProfileBlock}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        draggable
        theme="light"
        transition={Bounce}
      />
      <div className={styles.header}>
        <h3>Hồ sơ của tôi</h3>
        <span>Quản lý thông tin hồ sơ để bảo mật tài khoản</span>
      </div>
      <form className={styles.userProfileForm}>
        <div className={styles.leftForm}>
          {/* <div className={styles.formGroup}>
            <label className={styles.label}>Tên đăng nhập</label>
            <span>{userProfile.username}</span>
          </div> */}
          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="name">
              Tên
            </label>
            <TextField
              id="name"
              placeholder="Điền tên"
              value={userProfile.name}
              label={t("name")}
              onChange={(e) =>
                setUserProfile({
                  ...userProfile,
                  name: e.target.value,
                })
              }
              variant="outlined"
              size="small"
              sx={{
                width: "60%",
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: "#e7851a",
                  },
                },
                "& .MuiInputLabel-root": {
                  "&.Mui-focused": {
                    color: "#e7851a",
                  },
                },
              }}
            />
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>Email</label>
            <span>{userProfile.email}</span>
            <a
              className={styles.changeLink}
              onClick={() => handleOpen("isEmail")}
            >
              Thay Đổi
            </a>
            <Modal
              open={open.isEmail}
              onClose={() => handleClose("isEmail")}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={modalStyle}>
                <h3 className={styles.h3} id="modal-modal-title">
                  Thay đổi địa chỉ Email
                </h3>
                <TextField
                  error={error.email}
                  id="new-email"
                  label={t("email")}
                  variant="outlined"
                  margin="normal"
                  size="medium"
                  value={userProfile.email}
                  fullWidth
                  onChange={(e) => handleEmailChange(e.target.value)}
                />
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <InputOTP OTPValue={OTP} setOTPValue={setOTP} />
                </div>
                <div style={{ width: "50%", marginTop: "20px" }}>
                  <PrimaryButton text={"Xác nhận"} onClick={handleSaveEmail} />
                </div>
              </Box>
            </Modal>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>Số điện thoại</label>
            <span>{userProfile.phone}</span>
            <a
              className={styles.changeLink}
              onClick={() => handleOpen("isPhone")}
            >
              Thay Đổi
            </a>
            <Modal
              open={open.isPhone}
              onClose={() => handleClose("isPhone")}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={modalStyle}>
                <h3 className={styles.h3} id="modal-modal-title">
                  Thay đổi số điện thoại
                </h3>
                <TextField
                  error={error.phone}
                  id="new-phone"
                  label={t("email")}
                  variant="outlined"
                  margin="normal"
                  size="medium"
                  value={userProfile.phone}
                  fullWidth
                  onChange={(e) => handlePhoneChange(e.target.value)}
                />
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <InputOTP OTPValue={OTP} setOTPValue={setOTP} />
                </div>
                <div style={{ width: "50%", marginTop: "20px" }}>
                  <PrimaryButton text={"Xác nhận"} onClick={handleSavePhone} />
                </div>
              </Box>
            </Modal>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>Giới tính</label>
            <FormControl component="fieldset" className={styles.radioGroup}>
              <RadioGroup
                row
                value={userProfile.gender}
                onChange={(e) =>
                  setUserProfile({
                    ...userProfile,
                    gender: e.target.value,
                  })
                }
              >
                <FormControlLabel
                  value="male"
                  checked={userProfile.gender === "male"}
                  control={
                    <Radio
                      sx={{
                        color: "#e7851a",
                        "&.Mui-checked": { color: "#e7851a" },
                      }}
                    />
                  }
                  label={t("male")}
                />
                <FormControlLabel
                  value="female"
                  checked={userProfile.gender === "female"}
                  control={
                    <Radio
                      sx={{
                        color: "#e7851a",
                        "&.Mui-checked": { color: "#e7851a" },
                      }}
                    />
                  }
                  label={t("female")}
                />
                <FormControlLabel
                  value="another_gender"
                  checked={userProfile.gender === "another_gender"}
                  control={
                    <Radio
                      sx={{
                        color: "#e7851a",
                        "&.Mui-checked": { color: "#e7851a" },
                      }}
                    />
                  }
                  label={t("another_gender")}
                />
              </RadioGroup>
            </FormControl>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>Ngày sinh</label>
            <span>{userProfile.dob}</span>
            <a
              className={styles.changeLink}
              onClick={() => handleOpen("isDateOfBirth")}
            >
              Thay Đổi
            </a>
            <Modal
              open={open.isDateOfBirth}
              onClose={() => handleClose("isDateOfBirth")}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={modalStyle}>
                <h3 className={styles.h3} id="modal-modal-title">
                  Thay đổi Ngày sinh
                </h3>
                <TextField
                  error={error.dob}
                  margin="normal"
                  name="date"
                  label={t("dob")}
                  type="date"
                  fullWidth
                  value={userProfile.dob}
                  onChange={(e) => handleDOBChange(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
                <div style={{ width: "50%", marginTop: "20px" }}>
                  <PrimaryButton text={"Xác nhận"} onClick={handleSaveDOB} />
                </div>
              </Box>
            </Modal>
          </div>
          <div className={styles.formGroup}>
            <label className={styles.label}>Địa chỉ</label>
            {userProfile.street === t("not_set") &&
            userProfile.ward === t("not_set") &&
            userProfile.district === t("not_set") &&
            userProfile.city === t("not_set") ? (
              t("not_set")
            ) : (
              <span>
                {userProfile.street != t("not_set")
                  ? `${userProfile.street}, `
                  : ""}
                {userProfile.ward != t("not_set")
                  ? `${userProfile.ward}, `
                  : ""}
                {userProfile.district != t("not_set")
                  ? `${userProfile.district}, `
                  : ""}
                {userProfile.city != t("not_set")
                  ? `${userProfile.city}, `
                  : ""}
              </span>
            )}
            <a
              className={styles.changeLink}
              onClick={() => handleOpen("isAddress")}
            >
              Thay Đổi
            </a>
            <AddressInputModal
              open={open}
              onSave={handleSaveAddress}
              onCancel={() => handleClose("isAddress")}
              initialAddress={null}
            />
          </div>
          <div className={styles.formGroup}>
            <div className={styles.saveButton}>
              <PrimaryButton
                type={"submit"}
                text={t("save")}
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
        <div className={styles.rightForm}>
          <div className={styles.userAvatar}>
            <ImageWithFallback
              loading="lazy"
              className={styles.avatarImg}
              src={userProfile.avatar}
              alt="avatar"
            />
            <input
              id="avatar-input"
              style={{ display: "none" }}
              type="file"
              accept=".jpg,.jpeg,.png"
              onChange={handleAvatarChange}
            />
            <label
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
              htmlFor="avatar-input"
            >
              <Button
                variant="contained"
                component="span"
                style={{
                  backgroundColor: "var(--orange)",
                  marginBottom: "10px",
                }}
              >
                Chọn ảnh
              </Button>
            </label>
          </div>
        </div>
      </form>
    </div>
  );
}
